<section-info></section-info>
<form [formGroup]="stipendiumForm" class="stipendiumform">
  <div class="stipendium-upper-form">
    <kendo-formfield class="textbox-field">
      <kendo-label class="form-label" for="title" text="{{'stipendium.title' | translate}} *"
        [infotooltip]="'stipendium.titel'"></kendo-label>
      <kendo-textbox id="title" formControlName="title" showSuccessIcon="initial" showErrorIcon="initial"
        [appinfotext]="'stipendium.titel'" preventEmptyFormatter [maxlength]=200></kendo-textbox>
    </kendo-formfield>

    <kendo-formfield class="numeric-field">
      <kendo-label class="form-label" for="beantragteFoerdersumme"
        text="{{'stipendium.beantragteFoerdersumme' | translate}} *"
        [infotooltip]="'stipendium.beantragteFoerdersumme'"></kendo-label>
      <kendo-numerictextbox id="beantragteFoerdersumme" formControlName="beantragteFoerdersumme" [autoCorrect]="true"
        [min]="0" [format]="currencyFormatOptions" [appinfotext]="'stipendium.beantragteFoerdersumme'"
        [spinners]="false">
      </kendo-numerictextbox>
    </kendo-formfield>

    <hr class="col-span-2" />

    <div class="stipendiumFormColumn">
      <kendo-formfield class="textbox-field">
        <kendo-label class="form-label" [for]="studienbeginn" text="{{'stipendium.studienbeginn' | translate }} *"
          [infotooltip]="'stipendium.studienbeginn'"></kendo-label>
        <kendo-datepicker #studienbeginn (valueChange)="onStudienbeginnChange($event)" formControlName="studienbeginn"
          [appinfotext]="'stipendium.studienbeginn'" [format]="dateFormat"
          [incompleteDateValidation]="true"></kendo-datepicker>
      </kendo-formfield>
      <kendo-formfield class="textbox-field" [ngClass]="{ 'opacity-50': !studienbeginn.value }">

        <kendo-label class="form-label" [for]="studienende" text="{{'stipendium.studienende' |translate}} *"
          [infotooltip]="'stipendium.studienende'"></kendo-label>
        <kendo-datepicker #studienende formControlName="studienende" [min]="studienbeginn.value"
          [readonly]="!studienbeginn.value" [disabled]="!studienbeginn.value" [appinfotext]="'stipendium.studienende'"
          [incompleteDateValidation]="true" [format]="dateFormat"></kendo-datepicker>
      </kendo-formfield>

    </div>

    <div class="stipendiumFormColumn">
      <kendo-formfield class="textbox-field">
        <kendo-label class="form-label" for="universitaet" text="{{'stipendium.universitaet' | translate}} *"
          [infotooltip]="'stipendium.universitaet'"></kendo-label>
        <kendo-textbox id="universitaet" formControlName="universitaet" showSuccessIcon="initial"
          showErrorIcon="initial" [appinfotext]="'stipendium.universitaet'" preventEmptyFormatter
          [maxlength]=200></kendo-textbox>
      </kendo-formfield>

      <kendo-formfield class="textbox-field">
        <kendo-label class="form-label" for="studienfach" text="{{'stipendium.studienfach' | translate}} *"
          [infotooltip]="'stipendium.studienfach'"></kendo-label>
        <kendo-textbox id="studienfach" formControlName="studienfach" showSuccessIcon="initial" showErrorIcon="initial"
          [appinfotext]="'stipendium.studienfach'" preventEmptyFormatter [maxlength]=200></kendo-textbox>
      </kendo-formfield>

      <kendo-formfield class="textbox-field">
        <kendo-label class="form-label" [for]="angestrebterStudienabschluss"
          text="{{'stipendium.angestrebterStudienabschluss' | translate}} *"
          [infotooltip]="'stipendium.angestrebterStudienabschluss'"></kendo-label>
        <kendo-combobox formControlName="angestrebterStudienabschluss" [valuePrimitive]="true"
          #angestrebterStudienabschluss [allowCustom]="false" [data]="angestrebterStudienabschlussList"
          [valueField]="'Value'" [textField]="'Description'" [appinfotext]="'stipendium.angestrebterStudienabschluss'"
          kendoDropDownFilter>
        </kendo-combobox>
      </kendo-formfield>

      <kendo-formfield class="textbox-field">
        <kendo-label class="form-label" for="immatrikulationsnummer"
          text="{{'stipendium.immatrikulationsnummer' | translate}} *"
          [infotooltip]="'stipendium.immatrikulationsnummer'"></kendo-label>
        <kendo-textbox id="immatrikulationsnummer" formControlName="immatrikulationsnummer" showSuccessIcon="initial"
          showErrorIcon="initial" [appinfotext]="'stipendium.immatrikulationsnummer'" preventEmptyFormatter
          [maxlength]=200></kendo-textbox>
      </kendo-formfield>

    </div>
  </div>
  <div class="stipendium-bottom-form">
    <bank-data-kontakt [form]="antragstellerForm" [required]="true"></bank-data-kontakt>
  </div>
</form>